// src/utils/secureProvider.js

import { JsonRpcProvider } from 'ethers';
import secureFetch from './secureFetch';
import { extractDomain } from './secureFetch';
import PINNED_CERTIFICATES from './pinnedCertificates';

// Custom JsonRpcProvider that uses secureFetch for certificate pinning
export class SecureJsonRpcProvider extends JsonRpcProvider {
  constructor(url, network) {
    super(url, network);
    this.rpcUrl = url;
    
    // Check if the RPC domain is in our pinned certificates
    const domain = extractDomain(url);
    if (!PINNED_CERTIFICATES[domain]) {
      console.warn(`⚠️ Certificate pinning: RPC domain ${domain} is not in the pinned certificates list!`);
    } else {
      console.log(`✅ Using certificate pinning for RPC domain: ${domain}`);
    }
  }
  
  // Override the fetch method used internally by ethers
  async _fetch(url, payload, headers) {
    // Actually use our secureFetch wrapper that enforces certificate pinning
    const response = await secureFetch(url || this.rpcUrl, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json',
        ...headers
      }
    });
    
    const data = await response.json();
    return data;
  }
}

// Helper function to create a secure provider
export function createSecureProvider(rpcUrl, network) {
  return new SecureJsonRpcProvider(rpcUrl, network);
}